import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['fixed', 'nav', 'videoThumbnail']

  get scrollTop () {
    return document.documentElement.scrollTop || document.body.scrollTop
  }

  scroll () {
    this.navTarget.style.backgroundColor = this.scrollTop > 0 ? 'rgba(0,0,0,.8)' : null
    this.fixedTarget.style.top = this.scrollTop > 0 ? '0' : null
  }

  ejecutaVideo () {
    const iframe = document.createElement('iframe')
    iframe.src = 'https://www.youtube.com/embed/EVUhPy0Sfvo?autoplay=1'
    this.videoThumbnailTarget.replaceWith(iframe)
  }
}
